import { Fragment, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { useFormContext } from "react-hook-form";
import { classNames } from "../utils/formatters";
import { EQUIPMENT } from "../utils/constants";
import EquipmentBadge from "./EquipmentBadge";

export default function EquipmentSelect({ value, onChange, disabled }) {
  const equipment = Object.keys(EQUIPMENT);
  const { formState, watch } = useFormContext(); // retrieve all hook methods
  const { errors } = formState;

  const [query, setQuery] = useState("");
  const selected = value || [];

  const filteredEquipment =
    query === ""
      ? equipment
      : equipment.filter((key) =>
          EQUIPMENT[key].labelEs
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  return (
    <div className="">
      <h3 className="block text-sm font-medium text-gray-700">
        Equipamiento (extras, accesorios, modificaciones, etc.)
      </h3>
      <div className="grid grid-cols-2 gap-x-2 gap-y-2">
        <div className="col-span-2 sm:col-span-1">
          <Combobox
            value={selected}
            onChange={onChange}
            disabled={disabled}
            multiple
          >
            <div className="relative ">
              <div
                className={classNames(
                  "relative w-full cursor-default overflow-hidden rounded-md shadow-sm focus:ring-orange-500 focus:border-orange-500 block border border-gray-300 sm:text-sm",
                  errors.category
                    ? "ring-2 ring-red-500 ring-offset-2 ring-offset-white"
                    : ""
                )}
              >
                <Combobox.Button as="div">
                  <Combobox.Input
                    className={classNames(
                      "w-full border-none py-2 pl-3 pr-10 text-input leading-5 text-gray-900 focus:ring-0 normal-case",
                      disabled ? "bg-gray-100" : ""
                    )}
                    displayValue={(key) => query || ""}
                    onChange={(event) => setQuery(event.target.value)}
                  />
                  <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronUpDownIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </Combobox.Button>
                </Combobox.Button>
              </div>
              <Transition
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                afterLeave={() => setQuery("")}
              >
                <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10">
                  {filteredEquipment.length === 0 && query !== "" ? (
                    <Combobox.Option
                      className={({ active }) =>
                        `relative cursor-default select-none py-2 px-4 ${
                          active ? "bg-orange-500 text-white" : "text-gray-900"
                        }`
                      }
                      value={query.toLowerCase()}
                    >
                      {({ selected, active }) => (
                        <>
                          <span
                            className={`block truncate capitalize ${
                              selected ? "font-medium" : "font-normal"
                            }`}
                          >
                            Agregar: {query.toLowerCase()}
                          </span>
                          {selected ? (
                            <span
                              className={`absolute inset-y-0 right-0 flex items-center pr-3 ${
                                active ? "text-white" : "text-orange-500"
                              }`}
                            >
                              <CheckIcon
                                className="h-5 w-5"
                                aria-hidden="true"
                              />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Combobox.Option>
                  ) : (
                    filteredEquipment.map((key) => (
                      <Combobox.Option
                        key={EQUIPMENT[key]?.labelEs}
                        className={({ active }) =>
                          `relative cursor-default select-none py-2 px-4 ${
                            active
                              ? "bg-orange-500 text-white"
                              : "text-gray-900"
                          }`
                        }
                        value={key}
                      >
                        {({ selected, active }) => (
                          <>
                            <span
                              className={`block truncate ${
                                selected ? "font-medium" : "font-normal"
                              }`}
                            >
                              {EQUIPMENT[key]?.labelEs}
                            </span>
                            {selected ? (
                              <span
                                className={`absolute inset-y-0 right-0 flex items-center pr-3 ${
                                  active ? "text-white" : "text-orange-500"
                                }`}
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Combobox.Option>
                    ))
                  )}
                </Combobox.Options>
              </Transition>
            </div>
          </Combobox>
        </div>
        <div className="px-4 pt-2 pb-1 col-span-2 sm:col-span-1 rounded-md border border-gray-300">
          {selected.map((option) =>
            Object.keys(EQUIPMENT).includes(option) ? (
              <EquipmentBadge
                key={EQUIPMENT[option]?.labelEs}
                className="mr-1 mb-1"
                text={EQUIPMENT[option].labelEs}
              />
            ) : (
              <EquipmentBadge
                key={EQUIPMENT[option]?.labelEs}
                className="mr-1 mb-1 capitalize"
                text={option}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}
